
<template>
  <div class="ranking">
    <div class="contentBox cssFn_show">
      <p class="title">{{title|realSubstring(32)}}</p>
      <div class="content">
        <div v-show="tabIndex==0" class="tab1_content">
          <div class="normal" v-if="smallClassId">
            <div class="left">
              <img :src="datas.badge.imageUrl" alt>
              <span class="desc">{{datas.badge.title}}</span>
              <span class="desc_bottom">
                班内
                <span class="num">{{datas.studentRank.length}}</span>人已获得
              </span>
            </div>
            <div class="right scroll">
              <span
                :style="{color:i==userID?'#F57F22':''}"
                v-for="({n,i}) in datas.studentRank"
                :key="i"
              >{{n | realSubstring(8)}}</span>
            </div>
          </div>
          <div class="empty" v-else>
            <img src="../../../assets/img/video/badge_empty.png" alt>
            <p>亲爱的宝贝，你还没有小班，暂无徽章榜喔！</p>
          </div>
        </div>
        <div v-show="tabIndex==1" class="tab2_content">
          <div class="normal">
            <div class="left">
              <img :src="datas.badge.imageUrl" alt>
              <span class="desc">{{datas.badge.title}}</span>
            </div>
            <ul class="right scroll">
              <li
                v-for="({n,c,i}) in datas.smallClassRank"
                :key="i"
              >
                <span>{{n|realSubstring(20)}}</span>
                <span>
                  <span style="color:#F57F22">{{c}}</span>人已获得
                </span>
              </li>
            </ul>
          </div>
          <div class="bottom">
            <p v-if="smallClassId">
              我在:
              <span class="className">{{smallClassName|realSubstring(20)}}</span>
              <span class="classNum" style="color:#F57F22">{{datas.my}}</span>人已获得
            </p>
            <p v-else class="noSmall">亲爱的宝贝:你还没有小班，暂无小班信息喔！</p>
          </div>
        </div>
      </div>
      <div class="tabs">
        <span :class="{'cur':tabIndex==0}" @click="tabIndex=0">{{tabs[0]}}</span>
        <span :class="{'cur':tabIndex==1}" @click="tabIndex=1">{{tabs[1]}}</span>
      </div>
      <div class="close" @click="ranking_close"></div>
    </div>
  </div>
</template>

<script>
import { mapState} from "vuex";
export default {
  name: "ranking",
  data() {
    return {
      tabIndex: 0, //选项卡切换值
      tabs: ["徽章榜", "上榜班级"] //选项卡切换文字
    };
  },
  props: {
    datas: {
      type: Object,
      required: false
    },
  },
  computed: {
    ...mapState(["smallClassName", "smallClassId","userID"]),
    title() {
      if (this.tabIndex == 0 && this.smallClassName) {
        return `${this.smallClassName}徽章获奖名单`;
      } else {
        return this.tabs[this.tabIndex];
      }
    }
  },
  mounted(){
    this.$root.eventHub.$emit("createLog", {
      id: "LMTrackEventLiveRank",
      data: {
        unique_id: this.datas.unique_id,
        type:2
      }
    });
  },
  methods: {
    ranking_close() {
      this.$emit("ranking_close");
    }
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.cssFn_show {
  animation: bounceIn 0.5s 0.2s ease both;
  -webkit-animation: bounceIn 0.5s 0.2s ease both;
}
.ranking {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 81;
  background: rgba(0, 0, 0, 0.6);
  .contentBox {
    position: relative;
    width: 690px;
    height: 469px;
    background: url("../../../assets/img/video/rankingBG.png") no-repeat;
    background-size: 100%;
    .title {
      height: 80px;
      font-size: 27px;
      font-family: PingFang-Medium;
      line-height: 80px;
      color: #ffffff;
    }
    .tabs {
      height: 300px;
      position: absolute;
      bottom: 78px;
      left: -60px;
      font-size: 21px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      span {
        color: #c0c0c0;
        writing-mode: vertical-rl;

        cursor: pointer;
        margin: 4px auto;
        width: 60px;
        height: 150px;
        text-align: center;
        line-height: 60px;
        background: #fff;
        border-radius: 20px 0 0 20px;
      }
      .cur {
        background: rgba(255, 255, 255, 1);
        color: #f57f22;
      }
    }
    .close {
      background: url("../../../assets/img/video/ranking_close.png") no-repeat;
      position: absolute;
      top: -15px;
      right: -47px;
      width: 42px;
      height: 42px;
      z-index: 90;
      background-size: 100%;
      cursor: pointer;
    }
    .content {
      .left {
        display: flex;
        min-width: 263px;
        width: 263px;
        height: 295px;
        justify-content: flex-start;
        flex-direction: column;
        align-items: center;
        color: #004466;

        img {
          width: 147px;
          height: 147px;
          margin-top: 42px;
          margin-bottom: 20px;
        }
        .desc {
          font-family: PingFang_Medium;

          width: 126px;
          font-size: 18px;
          margin-bottom: 15px;
          position: relative;
          &::before {
            display: block;
            background: linear-gradient(to left, #597892, #fff); /* 标准的语法 */
            width: 30px;
            height: 2px;
            content: "";
            position: absolute;
            left: -42px;
            top: 13px;
            border-radius: 1px;
            margin-top: -1px;
          }
          &::after {
            display: block;
            border-radius: 1px;
             background: linear-gradient(to right, #597892, #fff); /* 标准的语法 */
            width: 30px;
            height: 2px;
            content: "";
            position: absolute;
            right: -42px;
             top: 13px;
            margin-top: -1px;
          }
        }

        .desc_bottom {
          font-size: 16px;
          font-family: PingFang_Medium;
        }
        .num {
          color: #f68b38;
        }
      }

      .scroll {
        overflow-y: scroll;
        margin-right: 5px;
        overflow-y: scroll;
        &::-webkit-scrollbar {
          width: 6px;
        }
        &::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 6px;
          box-shadow: inset 0 0 5px #d7d7d7;
          background: #d7d7d7;
          //   -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        }
        &::-webkit-scrollbar-track {
          /*滚动条里面轨道*/
          background: #fff;
          // -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        }
      }
      .tab1_content {
        .normal {
          padding: 20px 0 38px 0px;
          display: flex;
          height: 389px;
          justify-content: flex-start;

          .right {
            margin-left: 44px;
            width: 100%;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            font-family: PingFang_Medium;
            color: #004466;
            align-content: flex-start;
            span {
              display: inline-block;
              font-size: 21px;
              width: 33%;
             margin-top: 14px;
              text-align: left;
            }
          }
        }
        .empty {
          height: 389px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          img {
            margin-bottom: 30px;
            width: 383px;
            height: 164px;
          }
          p {
            color: #b8c3cb;
            font-size: 18px;
          }
        }
      }
      .tab2_content {
        color: #003057;
        .normal {
          display: flex;
          height: 315px;
          padding-top: 20px;
          .right {
            font-family: PingFang_Medium;
            font-size: 21px;

            width: 100%;
          }
          li {
            display: flex;
            justify-content: space-between;
            padding: 0 40px 0 10px;
            line-height: 30px;
            height: 30px;
          }
        }
        .bottom {
          height: 74px;
          line-height: 74px;
          text-align: left;
          padding-left: 50px;
          border-top: 1px solid #9ebfc8;
          font-size: 21px;
          .className {
            margin: 0 18px 0 5px;
          }
          .noSmall {
            font-size: 19px;
            color: #b8c3cb;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/video/badgeRank.vue